export const CONFIG_ITEMS = [
    'timeoutConfigurationItems',
    'realityCheckConfigurationItems',
    'sessionTimerConfigurationItems',
    'betLimitConfigurationItems',
    'loginLimitsConfigurationItems',
    'lossLimitConfigurationItems',
    'productLimitConfigurationItems'
];

export const LIMITS_WITHOUT_TYPES = {
    realityCheckConfigurationItems: 1,
    sessionTimerConfigurationItems: 2
};

export const ALL_LIMIT_TYPES = [
    'timeout',
    'realityCheck',
    'sessionTimer',
    'lossLimits',
    'betLimits',
    'loginLimits',
    'productBet',
    'productLoss'
];

export const PORTLET_TYPES_TO_APP_TYPES_MAP = {
    responsiblegamingbetlimits: 'betLimits',
    responsiblegaminglosslimits: 'lossLimits',
    responsiblegamingloginlimits: 'loginLimits',
    'product-loss-limit': 'productLoss',
    'product-bet-limit': 'productBet'
};
